import { CanActivateFn, Router } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { StorageService } from "../../../core/services/storage/storage.service";

export const authGuard: CanActivateFn = (_route, _state) => {
  const router: Router = inject(Router);
  const storageService = inject(StorageService);
  const platformId = inject(PLATFORM_ID);

  const token = storageService.getItem('TOKEN');

  if (!token) {
    // Ne rediriger que si on est sur le navigateur.
    // Le serveur laissera passer, et le client redirigera proprement après hydratation si besoin.
    if (isPlatformBrowser(platformId)) {
      router.navigate(['/auth/login']).then();
    }
    return false;
  }
  return true;
};
